import React, { createContext, useState, useEffect } from 'react';
import { fetchData } from '../Action/NewAction';

// Create Context
export const AcademicYearContext = createContext();

const AcademicYearProvider = ({ children }) => {
    const [academicYearId, setAcademicYearId] = useState(null);

    // Function to fetch and store the academic year ID
    const getAcademicYearId = async () => {
        // First check if it's available in localStorage
        const storedAcademicYearId = localStorage.getItem('academicYearId');
        
        if (storedAcademicYearId) {
            // If it exists in localStorage, use it
            setAcademicYearId(storedAcademicYearId);
            return;
        }

        // If not, fetch the academic year ID from API
        const { data, error } = await fetchData(`/api/SchoolAcademicYear/GetCurrentAcademicYear`);

        if (data && data.success) {
            const fetchedAcademicYearId = data.payload[0]?.academicYearId;
            setAcademicYearId(fetchedAcademicYearId);

            // Store it in localStorage for future use
            localStorage.setItem('academicYearId', fetchedAcademicYearId);
        } else {
            console.error('Error fetching academic year:', error);
        }
    };

    // Run the fetch on component mount
    useEffect(() => {
        getAcademicYearId();
    }, []);  // Empty dependency array ensures it runs once on component mount

    return (
        <AcademicYearContext.Provider value={{ academicYearId }}>
            {children}
        </AcademicYearContext.Provider>
    );
};

export default AcademicYearProvider;
